import { Filter, RuleOperator } from 'src/app/modules/core/store/models/filters.model';
import { IFieldFilterHandler, FieldFilterHandler } from 'src/app/modules/core/services/filter-runtime/field-handlers';

export class EnumerationFieldFilterHandler extends FieldFilterHandler implements IFieldFilterHandler {
  constructor() {
    super();
  }

  fieldMatchesFilter(value: any, filter: Filter): boolean {
    if (filter.operator === RuleOperator.In || filter.operator === RuleOperator.NotIn) {
      if (value === undefined || value === null) {
        return filter.operator === RuleOperator.NotIn;
      }
      const valueArray = value?.toString().split(',') ?? [];
      const filterArray = filter?.value?.toString().split(',') ?? [];

      const isMatch = valueArray?.some(v => filterArray?.includes(v));
      return filter.operator === RuleOperator.In ? isMatch : !isMatch;
    }

    const handler = this.comparisonHandlers[filter.operator];
    if (!handler) {
      return true;
    }

    const doesMatch = handler(value, filter);

    return doesMatch;
  }
}
